import { SportStatus } from 'entities/disciplines'
import { SportTypesLabel, SportTypesValue } from './types'

export const SPORT_STATUS_OPTIONS = [
    { value: SportStatus.Active, label: 'Aktivan' },
    { value: SportStatus.Inactive, label: 'Neaktivan' },
    { value: SportStatus.Archived, label: 'Arhiviran' },
] as const

export const SPORT_TYPE_OPTIONS = [
    { value: SportTypesValue.INDIVIDUAL, label: SportTypesLabel.INDIVIDUAL },
    { value: SportTypesValue.TEAM, label: SportTypesLabel.TEAM },
    { value: SportTypesValue.MIXED, label: SportTypesLabel.MIXED },
] as const
